// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9Rchh","left":"styles_left__3cnWp","desktopActions":"styles_desktopActions__1qamR","title":"styles_title__3XTFh"};